import React, { useCallback, useEffect, useRef, useState } from 'react';
import { GetChats, GetMessageFilter } from '../../API/GetData';
import { Button, Input } from 'antd';
import { CommentOutlined, InboxOutlined, SendOutlined } from '@ant-design/icons';
import { AuthData } from '../../Components/Global';
import { PostChat } from '../../API/PostData';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import HeaderTitle from '../../Components/HeaderTitle';

dayjs.extend(utc);
dayjs.extend(timezone);

const MenuLiveChat = () => {
    const [message, setMessage] = useState("");
    const [dataChats, setDataChats] = useState([]);
    const [chats, setChats] = useState(null);
    const [activeIndex, setActiveIndex] = useState(null);
    const [dataUserChat, setDataUserChat] = useState(null);

    const userAuth = AuthData();
    const Role = userAuth?.Role;

    const chatContainerRef = useRef(null);

    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    }, [chats]);

    // ALL CHAT
    const fetchDataChat = async () => {
        try {
            const response = await GetChats();
            setDataChats(response);
        } catch (error) {
            console.log(error);
        }
    };

    // MESSAGE
    const fetchDataMessage = useCallback(async () => {
        try {
            if (dataUserChat) {
                const res = await GetMessageFilter(dataUserChat.AccountId, dataUserChat.CustomerId);
                setChats(res);
            }
        } catch (error) {
            console.log(error);
        }
    }, [dataUserChat]);

    useEffect(() => {
        fetchDataChat();
        if (activeIndex !== null) {
            fetchDataChat();
            fetchDataMessage();
        }
    }, [activeIndex, fetchDataMessage]);

    const handleClick = (index, value) => {
        setActiveIndex(index);
        setDataUserChat(value);
    };

    const handleSend = async () => {
        if (!message.trim()) return;

        try {
            const payload = {
                ChatId: chats?.length ? chats[chats.length - 1].ChatId : "",
                AccountId: dataUserChat?.AccountId,
                CustomerId: dataUserChat?.CustomerId,
                ChatDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                Message: message,
                Role
            };

            const res = await PostChat(payload);
            if (res.status === 201) {
                fetchDataChat();
                fetchDataMessage();
                setMessage("");
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="">
            <HeaderTitle title="LIVE CHAT" subtitle="All Live Chat Customers" />
            <div className="w-full flex bg-white p-4 rounded-md h-[520px] border mt-2 ">
                {/* Sidebar */}
                <div className="w-2/5 border-r overflow-y-auto">
                    <div className="p-4 font-semibold bg-gray-100 sticky top-0">Chat List</div>
                    <div className="h-[400px] overflow-y-auto">
                        {dataChats.length > 0 ? dataChats.map((item, index) => (
                            <div
                                key={index}
                                onClick={() => handleClick(index, item)}
                                className={`cursor-pointer p-4 border-b transition ${activeIndex === index ? 'bg-primary-100' : 'hover:bg-gray-50'}`}
                            >
                                <div className="flex items-center justify-between">
                                    <h3 className="font-semibold text-lg">{item.CustomerName}</h3>
                                    <h3 className="text-sm text-gray-800">{dayjs.utc(item.ChatDate).format('HH:mm')}</h3>
                                </div>
                                <p className="text-sm text-gray-600">
                                    {item.SenderType === 'User' ? <span className="font-semibold">{item.Message}</span> : item.Message}
                                </p>
                            </div>
                        )) : (
                            <div className="h-full flex flex-col items-center justify-center gap-2 text-gray-500">
                                <CommentOutlined style={{ fontSize: "64px" }} />
                                <p>No chats available</p>
                            </div>
                        )}
                    </div>
                </div>

                {/* Chat Box */}
                <div className="w-3/5 flex flex-col">
                    {activeIndex !== null ? (
                        <>
                            <div className="p-4 bg-gray-100 font-semibold sticky top-0">{dataUserChat?.CustomerName}</div>
                            <div ref={chatContainerRef} className="flex-1 overflow-y-auto p-4 bg-gray-50">
                                {chats?.map((msg, index) => (
                                    <div key={index} className={`mb-2 flex ${msg.SenderType === 'Admin' ? 'justify-end' : ''}`}>
                                        <div className={`p-3 max-w-xs rounded-lg shadow-md ${msg.SenderType === 'Admin' ? 'bg-primary-500 text-white' : 'bg-white'}`}>
                                            <p>{msg.Message}</p>
                                            <p className="text-xs text-right opacity-70">{dayjs.utc(msg.MessageDate).format('HH:mm')}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="flex items-center gap-2 p-4 bg-white border-t sticky bottom-0">
                                <Input
                                    size="large"
                                    placeholder="Type a message..."
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    onPressEnter={handleSend}
                                />
                                <Button type="primary" shape="circle" icon={<SendOutlined />} onClick={handleSend} disabled={!message.trim()} />
                            </div>
                        </>
                    ) : (
                        <div className="h-full flex flex-col items-center justify-center text-gray-500">
                            <InboxOutlined style={{ fontSize: "64px" }} />
                            <p>Select a chat to start messaging</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MenuLiveChat;